"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _closeButton = require("@design/ui/close-button");
var _field = require("@design/ui/field");
var _Spinner = _interopRequireDefault(require("./common/Spinner"));
var _file = require("../utils/file");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
// A row in the attachment list. `id` is present once the file is persisted on
// the backend; staged-but-not-yet-uploaded files carry only a name.

var PromptAttachmentsSection = function PromptAttachmentsSection(_ref) {
  var attachments = _ref.attachments,
    onAddFiles = _ref.onAddFiles,
    onRemove = _ref.onRemove,
    loading = _ref.loading,
    maxReached = _ref.maxReached,
    maxCount = _ref.maxCount,
    readOnly = _ref.readOnly;
  var fileInputRef = (0, _react.useRef)(null);
  var fileInputId = (0, _react.useId)();
  var handleFileSelect = function handleFileSelect(e) {
    var files = Array.from(e.target.files || []);
    // Reset so picking the same file again re-fires the change event.
    e.target.value = "";
    if (files.length > 0) onAddFiles(files);
  };
  var addDisabled = loading || maxReached;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1.5 w-full",
    "data-sentry-component": "PromptAttachmentsSection",
    "data-sentry-source-file": "PromptAttachmentsSection.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center justify-between px-0.5",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_field.FieldLabel, {
        htmlFor: fileInputId,
        "data-sentry-element": "FieldLabel",
        "data-sentry-source-file": "PromptAttachmentsSection.tsx",
        children: "Attached files"
      }), !readOnly && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        onClick: function onClick() {
          var _fileInputRef$current;
          return (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
        },
        disabled: addDisabled,
        title: maxReached ? "Maximum of ".concat(maxCount, " files reached") : "Attach files",
        className: "flex items-center gap-1 text-[13px] font-medium bg-transparent border-none ".concat(addDisabled ? "text-[#B0AFAD] cursor-not-allowed" : "text-primary hover:text-background-primary-hover cursor-pointer"),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AddIcon, {
          width: 16,
          height: 16
        }), "Add"]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      id: fileInputId,
      ref: fileInputRef,
      type: "file",
      multiple: true,
      disabled: readOnly || addDisabled,
      accept: _file.ALLOWED_ATTACHMENT_EXTENSIONS.join(","),
      onChange: handleFileSelect,
      className: "hidden"
    }), loading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex items-center gap-2 px-1 py-2 text-[13px] text-[#6B7280]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {
        size: 16
      }), " Loading attachments..."]
    }) : attachments.length === 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "px-1 py-1 text-[13px] text-[#888786]",
      children: ["No files attached. Allowed: ", _file.ALLOWED_ATTACHMENT_EXTENSIONS_LABEL]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      className: "flex flex-col gap-1 w-full list-none p-0 m-0",
      children: attachments.map(function (row) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
          className: "flex items-center gap-2 w-full px-2.5 py-2 bg-[#F8F6F3] border border-[#E4E7EC] rounded",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.AttachFileIcon, {
            width: 15,
            height: 15,
            className: "flex-shrink-0 text-[#6B7280]"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "flex-1 truncate text-[13px] text-[#212528]",
            title: row.fileName,
            children: row.fileName
          }), readOnly ? null : row.busy ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {
            size: 16
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_closeButton.CloseButton, {
            onClick: function onClick() {
              return onRemove(row);
            },
            "aria-label": "Remove",
            title: "Remove",
            size: "icon-xs"
          })]
        }, row.key);
      })
    })]
  });
};
var _default = exports.default = PromptAttachmentsSection;